import axios from 'axios';

const instance = axios.create({
    // databaseURL
    baseURL: 'https://react-my-burger-f0564.firebaseio.com/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-orders.js